// pages/ForgotPassword.jsx
import React from 'react';
import { motion } from 'framer-motion';
import AuthHeroBit from '../../components/auth/AuthHeroBit';
import ForgotPasswordCard from '../../components/auth/ForgotPasswordCard';

const ForgotPasswordPage = () => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
            className="min-h-screen bg-ivory"
        >
            {/* Hero Section */}
            <AuthHeroBit
                title="Let’s restore your KROMAIC ritual."
                subtitle="Enter your email and we’ll help you regain access with care."
            />

            {/* Content Area */}
            <motion.div
                initial={{ y: 30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.2, duration: 0.6, ease: 'easeOut' }}
                className="relative z-10 -mt-16 sm:-mt-20 px-4"
            >
                <div className="max-w-md mx-auto">
                    <ForgotPasswordCard />
                </div>
            </motion.div>
        </motion.div>
    );
};

export default ForgotPasswordPage;
